import { ReactNode, useMemo } from "react";
import { renderMarkdownToHtml } from "../utils/markdown";

type MarkdownContentProps = {
  className?: string;
  content: string;
  emptyFallback?: ReactNode;
};

export const MarkdownContent = ({ className = "", content, emptyFallback = null }: MarkdownContentProps) => {
  const renderedContent = useMemo(() => renderMarkdownToHtml(content), [content]);

  if (!renderedContent) {
    return <>{emptyFallback}</>;
  }

  return (
    <div
      className={`markdown-content ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: renderedContent }}
    />
  );
};
